<template>
  <div v-if="recipe" class="pa-5">
    <h1 class="mb-10 text-4xl">{{ recipe.title }}</h1>

    <h3 class="mb-2 text-2xl">Zutaten:</h3>

    <div class="mb-4 pl-8">
      <ul class="list-disc">
        <li class="list-item" v-for="(ingredient, idx) in recipe.ingredients" :key="idx">
          {{ ingredient }}
        </li>
      </ul>
    </div>

    <h3 class="mb-2 text-2xl">Zubereitung:</h3>
    <div class="mb-4 pl-4">
      <p v-for="(instruction, index) in recipe.instructions" :key="index">
        {{ instruction }}
      </p>
    </div>
    <div v-if="recipe.sourceUrl?.length">
      <b>Quelle:</b>
      <a class="ml-3 text-blue-600 underline" :href="recipe.sourceUrl"> {{ recipe.sourceUrl }}</a>
    </div>

    <div><b>Zuletzt geändert am:</b> {{ getNiceDate(recipe.updatedAt) }}</div>
  </div>
</template>
<script src="./RecipeDetail.js"></script>
